import Breadcrumb from '@/components/base/Breadcrumb';
import SchemaOrg from '@/components/base/SchemaOrg';

const highlights = [
  { value: '15万+', label: '注册用户' },
  { value: '2000+', label: '正版韩漫' },
  { value: '99.9%', label: '服务可用率' },
  { value: '30+', label: '合作出版社' },
];

const timeline = [
  { year: '2020', title: '平台成立', description: '韩漫之家正式上线，首批引入100部正版韩漫作品' },
  { year: '2021', title: '快速成长', description: '用户突破5万，与10家韩国出版社达成合作，漫画数量翻倍' },
  { year: '2022', title: '体验升级', description: '推出下拉式阅读模式，全面优化移动端体验，支持高清画质' },
  { year: '2023', title: '生态扩展', description: '引入VIP会员体系，推出个性化推荐算法，用户突破10万' },
  { year: '2024', title: '行业领先', description: '用户突破15万，成为中文互联网韩漫阅读首选平台' },
];

const reviews = [
  {
    name: '漫画迷小王',
    text: '韩漫之家真的是我用过最好的韩漫平台！画质太清晰了，下拉式阅读超级流畅，追更速度也很快。',
    rating: 5,
  },
  {
    name: '追更达人Lina',
    text: '自从用了韩漫之家，再也没有去过其他平台。正版授权让人放心，分类也很清晰，找漫画特别方便。',
    rating: 5,
  },
  {
    name: '漫画阅读爱好者',
    text: 'VIP会员性价比很高，每天都有更新提醒。客服响应也很快，之前有个问题很快就解决了。',
    rating: 4,
  },
];

export default function AboutPage() {
  return (
    <>
      <SchemaOrg
        type="Organization"
        data={{
          name: '韩漫之家',
          url: 'https://www.hanmanzhijia.com',
          description: '韩漫之家是韩国漫画在线观看平台，拥有海量正版韩漫资源，支持下拉式阅读，画质高清，更新快。',
          address: {
            '@type': 'PostalAddress',
            addressLocality: '北京',
            addressRegion: '朝阳区',
            streetAddress: '望京SOHO',
          },
          contactPoint: {
            '@type': 'ContactPoint',
            telephone: '400-888-6666',
            contactType: 'customer service',
            email: 'contact@hanmanzhijia.com',
          },
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '关于我们 - 韩漫之家',
          description: '了解韩漫之家品牌故事、发展历程、用户口碑及联系方式。韩漫之家致力于打造最好的韩国漫画在线阅读平台。',
        }}
      />
      <Breadcrumb
        items={[
          { label: '首页', href: '/' },
          { label: '关于我们' },
        ]}
      />

      <main className="pb-14">
        {/* Brand Intro */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-6">
              关于韩漫之家
            </h1>
            <p className="text-foreground-600 leading-relaxed max-w-2xl mx-auto">
              韩漫之家创立于2020年，是一个专注于韩国漫画的在线观看平台。我们致力于为中文读者提供海量正版韩漫资源，打造极致的下拉式阅读体验。
              经过多年的发展，韩漫之家已与30多家韩国知名出版社建立了长期合作关系，平台拥有超过2000部正版韩漫作品，累计服务超过15万用户。
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mt-12">
              {highlights.map((item) => (
                <div key={item.label} className="text-center">
                  <p className="font-display text-3xl md:text-4xl text-primary-500">{item.value}</p>
                  <p className="text-sm text-foreground-500 mt-1">{item.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Timeline */}
        <section className="py-14 md:py-20 px-4 md:px-6">
          <div className="max-w-3xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-10">
              发展历程
            </h2>
            <div className="relative">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 -translate-x-1/2"></div>
              <div className="space-y-8">
                {timeline.map((item, index) => (
                  <div key={item.year} className={`relative flex items-start gap-6 ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                    <div className="md:w-1/2 flex-shrink-0"></div>
                    <div className="absolute left-4 md:left-1/2 w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-white -translate-x-1/2 z-10">
                      <span className="text-xs font-bold">{index + 1}</span>
                    </div>
                    <div className="md:w-1/2 pl-12 md:pl-0 md:px-8">
                      <div className="bg-background-50 border border-background-200/70 rounded-lg p-4 md:p-5">
                        <span className="text-xs font-medium text-primary-500">{item.year}</span>
                        <h3 className="font-heading font-semibold text-foreground-900 mt-1">{item.title}</h3>
                        <p className="text-sm text-foreground-600 mt-1">{item.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Reviews */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-10">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {reviews.map((review, index) => (
                <div key={index} className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-sm ${i < review.rating ? 'ri-star-fill text-yellow-500' : 'ri-star-line text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">{review.text}</p>
                  <p className="text-xs font-medium text-foreground-900">—— {review.name}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="py-14 md:py-20 px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-10">
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center p-6 bg-background-50 border border-background-200/70 rounded-lg">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-1">商务合作</h3>
                <p className="text-sm text-foreground-500">business@hanmanzhijia.com</p>
              </div>
              <div className="text-center p-6 bg-background-50 border border-background-200/70 rounded-lg">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                  <i className="ri-customer-service-line text-xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-1">客服支持</h3>
                <p className="text-sm text-foreground-500">400-888-6666</p>
              </div>
              <div className="text-center p-6 bg-background-50 border border-background-200/70 rounded-lg">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mx-auto mb-3">
                  <i className="ri-map-pin-line text-xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-1">公司地址</h3>
                <p className="text-sm text-foreground-500">北京市朝阳区望京SOHO</p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}